export class Brand {
  public id?: number;
  public code: string;
  public name:string;
  public logo:string;
}



// WEBPACK FOOTER //
// ./src/app/models/brand.model.ts